import React from 'react'
import UnAuthorized from '@/components/security/UnAuthorized'
import _ from 'lodash'
import store from '../redux'
// return null - waiting for userInfo to authorize
// return true - pass authorization
// return false - failed authorization
const hasPermission = permission => {
  const { account, permissions } = store.getState().commonStore
  if (account) {
    if (_.isArray(permission)) {
      return _.intersection(permissions, permission).length > 0
    } else {
      return (permissions || []).includes(permission)
    }
  } else {
    // if userId is empty means api call for user info is still not returned.
    return null
  }
}
const hasRolePermission = role => {
  // role需要全小写
  const { account, roles } = store.getState().commonStore
  if (account) {
    if (_.isArray(role)) {
      return _.intersection(roles, role).length > 0
    } else {
      return (roles || []).includes(role)
    }
  } else {
    // if userId is empty means api call for user info is still not returned.
    return null
  }
}
const hasCategoryPermission = category => {
  const { account, categorys } = store.getState().commonStore
  if (account) {
    if (_.isArray(category)) {
      return _.intersection(categorys, category).length > 0
    } else {
      return (categorys || []).includes(category)
    }
  } else {
    // if userId is empty means api call for user info is still not returned.
    return null
  }
}

// check authorization
function withPermission(permission) {
  // authorization logic
  return WrappedComponent => props => {
    // permission is null - means doesn't need any permission
    const isPermitted = !permission || hasPermission(permission)
    switch (isPermitted) {
      case true:
        return <WrappedComponent {...props} />
      case false:
        return <UnAuthorized {...props} />
      default:
        // important! display authorize result only when user info is returned from api.
        return null
    }
  }
}

function listenResizeEvent(WrappedComponent) {
  return class II extends WrappedComponent {
    onWindowResize(event) {
      if (super.onWindowResize) {
        super.onWindowResize(event)
      }
    }
    /**
     * Add event listener
     */
    componentDidMount() {
      super.componentDidMount && super.componentDidMount()
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }

    /**
     * Remove event listener
     */
    componentWillUnmount() {
      super.componentWillUnmount && super.componentWillUnmount()
      window.removeEventListener('resize', this.onWindowResize.bind(this))
    }
  }
}

// 获取有权限的第一个path
const getMenusFirstPath = list => {
  let firstPath = ''
  for (let idx = 0; idx < list.length; idx++) {
    const item = list[idx]
    if (isVisibleItem(item)) {
      if (hasVisibleChildren(item)) {
        return getMenusFirstPath(item.children)
      } else {
        if (item.component) {
          firstPath = item.key
        }
      }
    }
    if (firstPath) {
      break
    }
  }
  if (firstPath) {
    return firstPath
  } else {
    return ''
  }
}
const isVisibleItem = item => {
  return !item.hidden && (!item.permission || hasPermission(item.permission))
}
const isVisibleItemStrict = item => {
  return !item.hidden && hasPermission(item.permission)
}
const hasVisibleChildren = item => {
  return item.children && item.children.some(child => isVisibleItem(child))
}

export {
  hasPermission,
  hasRolePermission,
  hasCategoryPermission,
  withPermission,
  listenResizeEvent,
  isVisibleItem,
  isVisibleItemStrict,
  hasVisibleChildren,
  getMenusFirstPath
}
